<template>
    <div class="row">
        <div class="col-12 text-center">
            <span class="fa-stack fa-lg " @click="takePicture">
                <i class="fa fa-circle fa-stack-2x  text-warning"></i>
                <i class="fa fa-camera fa-stack-1x fa-inverse"></i>
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Picture",
        data() {
            return {
                blob:null,imagePath:null,dataUrl:null,error:[]
            };
        },
        methods:
        {
            takePicture() {
                console.log(navigator.camera)
                if (navigator.camera) {

                    navigator.camera.getPicture(result => {
                        console.log("cam")
                        this.imagePath = result,
                        this.setPicture(result)
                    }, this.onFail, {
                        quality: 30, sourceType: navigator.camera.PictureSourceType.CAMERA,
                        destinationType: navigator.camera.DestinationType.DATA_URL,
                        encodingType: navigator.camera.EncodingType.JPEG,
                        correctOrientation: true
                    });
                    console.log('2')
                } else {
                    // If the navigator.camera is not available display generic error to the user.

                    console.log('3')
                }
            },
            onFail(message) {
                alert('Failed because: ' + message);
            },
            sendPicture()
            {
                this.$emit('returnPicture', [this.blob,this.dataUrl])
            },
            // Set the picture path in the data of the vue
            // this action will automatically update the view.
            setPicture(imagePath) {
                console.log(imagePath)


                this.blob = this.getBlob(imagePath, 'jpeg', 512)
                this.dataUrl = 'data:image/jpeg;base64,' + imagePath

                this.sendPicture()
            },

            getBlob(b64Data, contentType, sliceSize) {
                contentType = contentType || '';
                sliceSize = sliceSize || 512;

                let byteCharacters = window.atob(b64Data);
                let byteArrays = [];

                for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                    let slice = byteCharacters.slice(offset, offset + sliceSize);

                    let byteNumbers = new Array(slice.length);
                    for (let i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                    }

                    let byteArray = new Uint8Array(byteNumbers);

                    byteArrays.push(byteArray);
                }

                let blob = new Blob(byteArrays, {type: contentType});
                return blob;
            },

        }
    }
</script>

<style scoped>

</style>